import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { DirtyFormDialogResponse } from './dirty-form-dialog-response';

@Component({
  selector: 'hb-dirty-form-dialog',
  templateUrl: './dirty-form-dialog.component.html',
})
export class DirtyFormDialogComponent implements OnInit, OnDestroy {
  dataIsValid: boolean = true;
  afterClosed = new Subject<DirtyFormDialogResponse>();
  private hideSub: Subscription;
  readonly dataValidMessage: string = this.i18NextPipe.transform('DirtyFormDialog.DataValidMessage');
  readonly dataInvalidMessage: string = this.i18NextPipe.transform('DirtyFormDialog.DataInvalidMessage');

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private i18NextPipe: I18NextPipe
  ) { }

  ngOnInit() {
    this.hideSub = this.modalService.onHide.subscribe(() => this.submit(false));
  }

  ngOnDestroy() {
    this.hideSub.unsubscribe();
  }

  submit(leave: boolean, save: boolean = false) {
    this.afterClosed.next({ leave, save });
    this.hideSub.unsubscribe();
    this.bsModalRef.hide();
  }

  @HostListener('window:keyup.enter', ['$event'])
  handleEnter() {
    if (this.dataIsValid) {
      this.submit(false, true);
    }
  }
}
